import * as React from "react";
const ProfileCircleIcon = (props) => (
  <svg
    width={34}
    height={35}
    viewBox="0 0 34 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.1702 19.7313C17.1418 19.7313 17.0993 19.7313 17.071 19.7313C17.0285 19.7313 16.9718 19.7313 16.9293 19.7313C13.7135 19.6292 11.3052 17.0479 11.3052 13.8688C11.3052 10.6313 13.8693 7.9917 17.0143 7.9917C20.1593 7.9917 22.7235 10.6313 22.7235 13.8688C22.7093 17.0625 20.2868 19.6292 17.2127 19.7313C17.1843 19.7313 17.1843 19.7313 17.1702 19.7313ZM17.0002 10.1646C15.0168 10.1646 13.416 11.8271 13.416 13.8542C13.416 15.8521 14.9318 17.4709 16.8585 17.5438C16.901 17.5292 17.0427 17.5292 17.1843 17.5438C19.0827 17.4417 20.5702 15.8375 20.5843 13.8542C20.5843 11.8271 18.9835 10.1646 17.0002 10.1646Z"
      fill="currentColor"
    />
    <path
      d="M16.9998 33.177C13.189 33.177 9.54818 31.7187 6.72902 29.0646C6.47402 28.8312 6.36068 28.4812 6.38902 28.1458C6.57318 26.4104 7.62152 24.7916 9.36402 23.5958C13.5857 20.7083 20.4282 20.7083 24.6357 23.5958C26.3782 24.8062 27.4265 26.4104 27.6107 28.1458C27.6532 28.4958 27.5257 28.8312 27.2707 29.0646C24.4515 31.7187 20.8107 33.177 16.9998 33.177ZM8.61318 27.8541C10.9648 29.8812 13.9257 30.9895 16.9998 30.9895C20.074 30.9895 23.0348 29.8812 25.3865 27.8541C25.1315 26.9646 24.4515 26.1041 23.4457 25.4041C19.9607 23.0125 14.0532 23.0125 10.5398 25.4041C9.53402 26.1041 8.86818 26.9646 8.61318 27.8541Z"
      fill="currentColor"
    />
    <path
      d="M17.0002 33.177C8.59933 33.177 1.771 26.1479 1.771 17.5C1.771 8.85204 8.59933 1.82288 17.0002 1.82288C25.401 1.82288 32.2293 8.85204 32.2293 17.5C32.2293 26.1479 25.401 33.177 17.0002 33.177ZM17.0002 4.01038C9.77516 4.01038 3.896 10.0625 3.896 17.5C3.896 24.9375 9.77516 30.9895 17.0002 30.9895C24.2252 30.9895 30.1043 24.9375 30.1043 17.5C30.1043 10.0625 24.2252 4.01038 17.0002 4.01038Z"
      fill="currentColor"
    />
  </svg>
);
export default ProfileCircleIcon;
